const FOUNDING_AMOUNTS = [20, 30, 40, 50, 60, 70, 80];
const FOUNDING_PRODUCT = /^founding_member_annual_(\d+)(?::[\w-]+)?$/;
// The RevenueCat dashboard must retain this offering identifier for web memberships and tips.
const WEB_OFFERING = "web";

let configuration = Promise.resolve();
let configuredKey;

export function revenueCatFor(sdk, apiKey, userId) {
  configuration = configuration
    .catch(() => {})
    .then(async () => {
      if (sdk.Purchases.isConfigured() && configuredKey !== apiKey) {
        sdk.Purchases.getSharedInstance().close();
      }
      if (!sdk.Purchases.isConfigured()) {
        const purchases = sdk.Purchases.configure({ apiKey, appUserId: userId });
        configuredKey = apiKey;
        return purchases;
      }
      const purchases = sdk.Purchases.getSharedInstance();
      if (purchases.getAppUserId() !== userId) await purchases.changeUser(userId);
      return purchases;
    });
  return configuration;
}

export function foundingOptions(offerings) {
  const options = new Map();
  for (const pkg of offerings.all?.[WEB_OFFERING]?.availablePackages ?? []) {
    const product = pkg.webBillingProduct;
    const match = /^founding_member_annual_(\d+)$/.exec(product.identifier);
    const amount = match ? Number(match[1]) : null;
    if (FOUNDING_AMOUNTS.includes(amount) && product.normalPeriodDuration === "P1Y" && product.price?.formattedPrice) {
      options.set(amount, { amount, package: pkg, price: product.price.formattedPrice });
    }
  }
  return [...options.values()].sort((left, right) => left.amount - right.amount);
}

export function tipPackage(offerings) {
  return (offerings.all?.[WEB_OFFERING]?.availablePackages ?? []).find((pkg) => {
    const product = pkg.webBillingProduct;
    return product.identifier === "tip_jar" && product.normalPeriodDuration === null && product.price?.formattedPrice;
  });
}

export function blocksFoundingPurchase(info) {
  if (info?.entitlements?.active?.founding_member) return true;
  if (Array.from(info?.activeSubscriptions ?? []).some((id) => FOUNDING_PRODUCT.test(id))) return true;
  return foundingSubscriptions(info).some((subscription) =>
    Boolean(subscription.isActive || subscription.willRenew || subscription.autoResumeDate)
  );
}

export function managementURL(info) {
  const subscriptions = foundingSubscriptions(info);
  const subscription = subscriptions.find((item) => item.isActive || item.willRenew || item.autoResumeDate);
  const candidate = subscription?.managementURL ?? info?.managementURL ?? subscriptions[0]?.managementURL;
  try {
    const url = new URL(candidate);
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}

function foundingSubscriptions(info) {
  return Object.values(info?.subscriptionsByProductIdentifier ?? {}).filter((subscription) =>
    FOUNDING_PRODUCT.test(subscription.productIdentifier)
  );
}
